import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Proizvodjac } from './proizvodjac';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-proizvodjac-modal-update',
  templateUrl: './proizvodjac-modal-update.component.html'
})
export class ProizvodjacModalUpdateComponent extends BaseModalUpdateComponent<Proizvodjac> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Proizvodjac>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
